import React from 'react';

/**
 * Fixed-position parallax background: a faint grid plus three large
 * blurred orbs that translate slightly with scroll. Pure decoration —
 * `pointerEvents: none` so it never blocks interactions.
 *
 * Orb sizes are viewport-relative rather than fixed pixels. At 800px across
 * they were a soft wash behind a desktop layout and a single flat colour
 * filling a phone screen, which is the same decoration doing the opposite
 * job. The grid squares shrink for the same reason.
 */
export default function ParallaxBg({ t, scrollY }) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 0, overflow: 'hidden', pointerEvents: 'none', background: t.bg }}>
      <div style={{ position: 'absolute', inset: 0, backgroundImage: `linear-gradient(${t.grid} 1px, transparent 1px), linear-gradient(90deg, ${t.grid} 1px, transparent 1px)`, backgroundSize: 'clamp(34px, 8vw, 60px) clamp(34px, 8vw, 60px)' }} />
      <div style={{ position: 'absolute', width: 'min(800px, 130vw)', height: 'min(800px, 130vw)', borderRadius: '50%', background: `radial-gradient(circle, ${t.orb1} 0%, transparent 70%)`, top: '-15%', left: '-20%', transform: `translateY(${-scrollY * 0.2}px)`, transition: 'transform 0.06s linear' }} />
      <div style={{ position: 'absolute', width: 'min(600px, 100vw)', height: 'min(600px, 100vw)', borderRadius: '50%', background: `radial-gradient(circle, ${t.orb2} 0%, transparent 70%)`, top: '30%', right: -100, transform: `translateY(${-scrollY * 0.1}px)`, transition: 'transform 0.06s linear' }} />
      <div style={{ position: 'absolute', width: 'min(500px, 85vw)', height: 'min(500px, 85vw)', borderRadius: '50%', background: `radial-gradient(circle, ${t.orb3} 0%, transparent 70%)`, bottom: '10%', left: '30%', transform: `translateY(${-scrollY * 0.3}px)`, transition: 'transform 0.06s linear' }} />
    </div>
  );
}
